import { UserRoles } from '../data/models/user';
import store from '../data/store';

export const isAdmin = () => {
	const userRole = store.getState()?.authState?.user?.role;
	return userRole === UserRoles.ADMIN.id;
};
